export default __webpack_public_path__ + "static/media/IMG_4998-min.052cf8d6.JPG";